import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

import FormGroup from '../FormGroup'

const ImageGrid = styled.div`
    display: grid;
    row-gap: 10px;
    column-gap: 10px;

    grid-template-columns: repeat(1, minmax(0, 1fr));

    ${breakpoint('tablet')`
        grid-template-columns: repeat(2, minmax(0, 1fr));
    `}

    ${breakpoint('laptop')`
        grid-template-columns: repeat(4, minmax(0, 1fr));
    `}
`

const StyledImageContainer = styled.div`
    position: relative;
    padding: 10px;
    cursor: pointer;
    box-shadow: inset 0 0 0px 1px #ddd;
    transition: box-shadow 0.1s ease-in-out;
    min-height: 60px;

    &.selected {
        box-shadow: inset 0 0 0px 4px ${props => props.theme.admin.colors.brand};
    }
`

const StyledImage = styled.img`
    width: 100%;
`

const StyledDescription = styled.p`
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    margin: 0;
    background: rgba(255, 255, 255, 0.6);
    padding: 10px;
    backdrop-filter: blur(5px);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`

const ImagePicker = ({
    name,
    label,
    help,
    placeholder,
    images = [],
    className = '',
    tooltip,
    disabled,
    ...props
}) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                return (
                    <FormGroup {...{ name, label, help, tooltip }}>
                        <ImageGrid>
                            {images?.map((img, idx) => {
                                return (
                                    <StyledImageContainer
                                        key={`image-${idx}`}
                                        onClick={e => {
                                            if (!disabled) {
                                                const selectedImages = field.value
                                                    ? [...field.value]
                                                    : []
                                                const imgIdx = selectedImages.indexOf(img['@id'])
                                                if (imgIdx > -1) {
                                                    selectedImages.splice(imgIdx, 1)
                                                    form.setFieldValue(name, selectedImages)
                                                } else {
                                                    form.setFieldValue(name, [
                                                        ...selectedImages,
                                                        img['@id'],
                                                    ])
                                                }
                                            }
                                        }}
                                        className={
                                            field?.value?.includes(img['@id']) ? 'selected' : ''
                                        }
                                        data-testid={`${field.name}-image-${idx}`}
                                    >
                                        <StyledImage src={img.location} />

                                        {img?.description?.length > 0 && (
                                            <StyledDescription>{img.description}</StyledDescription>
                                        )}
                                    </StyledImageContainer>
                                )
                            })}
                        </ImageGrid>
                    </FormGroup>
                )
            }}
        </Field>
    )
}

ImagePicker.displayName = 'ImagePicker'

ImagePicker.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    images: PropTypes.array.isRequired,
    className: PropTypes.string,
}

export default ImagePicker
